export type ICommonKind<T extends number | string> = { name: string; kind: T }
/** Kind名の取得 */
const useKindName =
  <T extends number | string>(
    kindList: ICommonKind<T>[]
  ): ((status: T) => string) =>
  (status: T): string => {
    const result = kindList.find((data) => data.kind === status)
    return result !== undefined ? result.name : ''
  }

export default useKindName
